import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "border rounded-lg template-image p-4 me-2 mt-2",
  height: "400px"
}
const _hoisted_2 = { height: "200px" }
const _hoisted_3 = { class: "fz-5" }
const _hoisted_4 = { class: "my-2" }
const _hoisted_5 = { class: "d-flex" }
const _hoisted_6 = ["value"]
const _hoisted_7 = {
  class: "position-relative",
  style: {"height":"18rem"}
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1)
const _hoisted_9 = [
  _hoisted_8
]

import {ref, onMounted} from "vue";
import { UserFile, UserFileImpl, deleteUserAsset, is_vrm } from "../../../utils/UserFile";
import { SessionUser } from "../../../utils/SessionUser";
import { MessageDialog } from "../../../../framework/frontend/MessageDialog";
import { NumberUtils } from "../../../utils/NumberUtils";
import CardThumbnail from "../ui/CardThumbnail.vue";
import SoundButton from "../ui/SoundButton.vue";
import VideoButton from "../ui/VideoButton.vue";
import ModelGltfButton from "../ui/ModelGltfButton.vue";
import ModelVrmButton from "../ui/ModelVrmButton.vue";
import VrmAnimButton from "../ui/VrmAnimButton.vue";
import ModelPlaneDetectArButton from "../ui/ModelPlaneDetectArButton.vue";
import { dayjs } from "../../../../framework/util/momentExtends";
import { translation } from "../../../lang/Translation";
import ToCanvasGlbButton from "../ui/ToCanvasGlbButton.vue";
import ImageSkyButton from "../ui/ImageSkyButton.vue";
import ImageElementButton from "../ui/ImageElementButton.vue";
import SrcElementButton from "../ui/SrcElementButton.vue";
import ImageSrcAndBoxElementButton from "../ui/ImageSrcAndBoxElementButton.vue";

interface Prop {
  item: UserFile;
  lastModified: string;
  size: number;
  index: number;
  listReload: ()=>void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FileCardSection',
  props: {
    item: null,
    lastModified: null,
    size: null,
    index: { default: 0 },
    listReload: null
  },
  setup(__props: any) {

const props = __props as { item: UserFile, lastModified: string, size: number, index: number, listReload: ()=>void };



const t = translation;
const userFile = ref(UserFileImpl.instance(""));
const lastModifiedDate = ref();
const type = ref("");
const isVrm = ref(false);

onMounted(() => {
  userFile.value = props.item;
  lastModifiedDate.value = dayjs(props.lastModified).format(`YYYY/MM/DD hh:mm:ss`);
  type.value = userFile.value.type;
  isVrm.value = is_vrm(userFile.value.assetPath);
});

/**
 * プロパティ
 */

const deleteAsset = async () => {
  const fileName = props.item.fileNameFromPath;
  const result = await deleteUserAsset(
    SessionUser.instance.userId,
    SessionUser.instance.token,
    fileName
  );
  if (result) {
    MessageDialog.info(`${fileName} ${t.to("を削除しました", "file_deleted")}`);
    props.listReload();
  }
  //
};

return (_ctx: any,_cache: any) => {
  const _component_lable = _resolveComponent("lable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(CardThumbnail, {
      "asset-path": __props.item.assetPath,
      type: __props.item.type
    }, null, 8, ["asset-path", "type"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(__props.index + 1) + ". " + _toDisplayString(userFile.value.fileNameFromPath), 1),
      _createElementVNode("p", null, _toDisplayString(_unref(NumberUtils).humanReadableFileSize(__props.size)), 1),
      _createElementVNode("p", null, _toDisplayString(lastModifiedDate.value), 1),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_lable, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t).to("ファイルパス", "file_path")), 1)
          ]),
          _: 1
        }),
        _createElementVNode("span", _hoisted_5, [
          _createElementVNode("input", {
            type: "text",
            class: "form-control",
            value: userFile.value.assetPath
          }, null, 8, _hoisted_6)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        (type.value === 'image')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(ImageElementButton, {
                "asset-path": userFile.value.assetPath,
                class: "w-100 my-1"
              }, null, 8, ["asset-path"]),
              _createVNode(ImageSkyButton, {
                "asset-path": userFile.value.assetPath,
                class: "w-100 my-1"
              }, null, 8, ["asset-path"]),
              _createVNode(ToCanvasGlbButton, {
                "asset-path": userFile.value.assetPath,
                "reload-call-back": __props.listReload,
                class: "w-100 my-1"
              }, null, 8, ["asset-path", "reload-call-back"]),
              _createVNode(ImageSrcAndBoxElementButton, {
                "asset-path": userFile.value.assetPath,
                class: "w-100 my-1"
              }, null, 8, ["asset-path"])
            ], 64))
          : _createCommentVNode("", true),
        _createVNode(VideoButton, {
          type: type.value,
          "asset-path": userFile.value.assetPath,
          class: "w-100 my-1"
        }, null, 8, ["type", "asset-path"]),
        _createVNode(SoundButton, {
          type: type.value,
          "asset-path": userFile.value.assetPath,
          class: "w-100 my-1"
        }, null, 8, ["type", "asset-path"]),
        (type.value === 'model')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(ModelGltfButton, {
                "is-vrm": isVrm.value,
                "asset-path": userFile.value.assetPath,
                class: "w-100 my-1"
              }, null, 8, ["is-vrm", "asset-path"]),
              _createVNode(ModelVrmButton, {
                "is-vrm": isVrm.value,
                "asset-path": userFile.value.assetPath,
                class: "w-100 my-1"
              }, null, 8, ["is-vrm", "asset-path"]),
              _createVNode(ModelPlaneDetectArButton, {
                "is-vrm": isVrm.value,
                "asset-path": userFile.value.assetPath,
                class: "w-100 my-1"
              }, null, 8, ["is-vrm", "asset-path"])
            ], 64))
          : _createCommentVNode("", true),
        (type.value === 'vrm_anim')
          ? (_openBlock(), _createBlock(VrmAnimButton, {
              key: 2,
              type: type.value,
              "asset-path": userFile.value.assetPath,
              class: "w-100 my-1"
            }, null, 8, ["type", "asset-path"]))
          : _createCommentVNode("", true),
        _createVNode(SrcElementButton, {
          "asset-path": userFile.value.assetPath,
          class: "w-100 my-1"
        }, null, 8, ["asset-path"]),
        _createElementVNode("button", {
          class: "btn btn-light w-100 my-1 position-absolute start-0 bottom-0",
          onClick: deleteAsset
        }, _hoisted_9)
      ])
    ])
  ]))
}
}

})